import {
    EngageDailyReportItem,
    EngageDailyReportReduced,
} from '../api/activityReport/types/ActivityReport';

export const groupEngageReport = (data: EngageDailyReportItem[]): EngageDailyReportReduced => {
    return data.reduce(
        (acc, item) => {
            acc.dailyReports.push(item);
            acc.totalAppointments += item.appointments;
            acc.totalCallBacks += item.callBacks;
            acc.totalCallsInbound += item.callsInbound;
            acc.totalCallsOutbound += item.callsOutbound;
            acc.totalSmsInbound += item.smsInbound;
            acc.totalSmsOutbound += item.smsOutbound;
            acc.totalGmailInbound += item.gmailInbound;
            acc.totalGmailOutbound += item.gmailOutbound;
            acc.totalRinglessVM += item.ringlessVM;
            return acc;
        },
        {
            dailyReports: [],
            totalAppointments: 0,
            totalCallBacks: 0,
            totalCallsInbound: 0,
            totalCallsOutbound: 0,
            totalSmsInbound: 0,
            totalSmsOutbound: 0,
            totalGmailInbound: 0,
            totalGmailOutbound: 0,
            totalRinglessVM: 0,
        } as EngageDailyReportReduced,
    );
};
